import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignIsSavingReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.isSaving = action.payload;
};

export default setDesignIsSavingReducer;
